import React from 'react';
import { WorkflowCanvas } from '../components/Workflow/WorkflowCanvas';

const CreateWorkflow = () => {
  return (
    <div className="flex bg-[var(--card-bg)]" style={{ height: 'calc(100vh - 130px)' }}>
      <div className="flex-1 flex flex-col">
        <WorkflowCanvas />
      </div>
    </div>
  );
};

export default CreateWorkflow;
